import axios from './base'

const url = {
  login: '/api/auth/login',
  logout: '/api/auth/logout',
  check: '/api/auth/check'
}

export default {
  async login ({ email, password }) {
    return await axios.post(url.login, {
      email,
      password
    })
  },
  async logout () {
    return await axios.post(url.logout)
  },
  async check () {
    return await axios.post(url.check)
  }
}
